import React from "react";

import { Avatar, Tooltip } from "antd";

import cardStyles from "./cardFriend.module.scss";
import { getUrlHttp } from "src/service/util.service";
import { ProfilePopover } from "../../../components/Popover";
import _ from "lodash";

interface FriendCardProps {
    id: string;
    image: string;
    firstname: string;
    lastname: string;
    onClick: any;
}

const FriendCard: React.FC<FriendCardProps> = ({
    id,
    image,
    firstname,
    lastname,
    onClick,
}) => {
    return (
        <ProfilePopover userId={id} imgURL={image} name={firstname +
            (_.isEmpty(lastname)
                ? ""
                : " " + lastname)}>
            <div
                style={{ maxWidth: 75, textAlign: "center", cursor: "pointer" }}
                onClick={() => onClick()}
                className={cardStyles.center}
            >
                {/*<div*/}
                {/*  className={cardStyles.personalImg}*/}
                {/*  style={{ backgroundImage: `url(${getUrlHttp(image)})` }}*/}
                {/*></div>*/}
                <Avatar size={50} src={getUrlHttp(image)} />
                <div style={{ paddingTop: ".75rem" }}>
                    {/*<Tooltip placement="top" title={firstname} color="#0f4c82">*/}
                    <div className={cardStyles.boxName}>{firstname}</div>
                    {/*</Tooltip>*/}
                    {/*<Tooltip placement="bottom" title={lastname} color="#0f4c82">*/}
                    <div className={cardStyles.boxName}>{lastname}</div>
                    {/*</Tooltip>*/}
                </div>
            </div>
        </ProfilePopover>
    );
};

export default FriendCard;
